
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.154 13.804a1.02 1.02 0 010 1.48c-.212.211-.423.317-.741.317s-.53-.106-.741-.317L.318 8.94a1.02 1.02 0 010-1.48l6.354-6.343a1.025 1.025 0 011.482 0 1.02 1.02 0 010 1.48L2.542 8.2l5.612 5.603z","fill":"#8DC540"}})])
          )
        }
      }
    